import React from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { Input } from 'reactstrap';

interface Props {
    value: number;
    onValueChange: (v: number) => void;
    name: string;
    placeholder?: string;
}

export const CurrencyInput: React.FC<Props> = ({
    value,
    onValueChange,
    name,
    placeholder,
}) => (
    <NumericFormat
        customInput={Input}
        className="form-control-alternative"
        thousandSeparator="."
        decimalSeparator=","
        prefix="R$ "
        decimalScale={2}
        fixedDecimalScale
        allowNegative={false}
        value={value}
        name={name}
        placeholder={placeholder}
        onValueChange={val => onValueChange(val.floatValue ?? 0)}
    />
);
